<template>
    <v-menu offset-y dark>
        <template v-slot:activator="{ on, value }">
            <v-btn tile class="toolbar-btn" text dark small v-on="on" height="48px">
                {{ $t($i18n.locale) }}
                <v-icon small>{{ value ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
            </v-btn>
        </template>
        <v-list tile small class="py-0" id="list" :color="$vuetify.theme.themes.dark.primary">
            <v-list-item small v-for="lang in langs" :key="lang" @click="onChangeLocale(lang)" class="text-uppercase small text-center">
                {{ $t(lang) }}
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { LocaleService } from '@/services/storage.service';
export default {
    props: ['color'],
    data() {
        return {
            langs: ['kz', 'ru'],
            isMenuOpened: false
        };
    },
    methods: {
        onChangeLocale(locale) {
            if (locale === this.$i18n.locale) return;
            this.$i18n.locale = locale;
            LocaleService.setLocale(locale);
        }
    }
};
</script>
<style lang="scss" scoped>
.small {
    font-size: 10px;
    line-height: 12px;
    padding: 0 8px;
    min-height: 30px;
    align-items: center;
}
</style>
